<template>
  <div id="toggle-menu" class="menu-icon" @click="toggleMenuState">
    <div id="nav-icon" :class="navIconClasses">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navigation',
  props: {
    navIconClasses: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  methods: {
    toggleMenuState () {
      this.$emit('toggle-menu-state')
    }
  }
}
</script>

<style lang="sass">
  @import ../assets/styles/scss/variables.scss
  @import ../assets/styles/scss/mixins.scss

  #nav-icon
    width: 24px
    height: 24px
    position: relative
    -webkit-transform: rotate(0deg)
    -moz-transform: rotate(0deg)
    -o-transform: rotate(0deg)
    transform: rotate(0deg)
    -webkit-transition: .5s ease-in-out
    -moz-transition: .5s ease-in-out
    -o-transition: .5s ease-in-out
    transition: .5s ease-in-out
    cursor: pointer

    @media screen and (min-width: $break-small)
      width: 32px
      height: 32px

    @media screen and (min-width: $break-medium)
      width: 38px
      height: 38px

    @media screen and (min-width: $break-large)
      width: 44px
      height: 44px

  #nav-icon span
    display: block
    position: absolute
    height: 2px
    width: 100%
    background: $mainColor
    opacity: 1
    left: 0
    -webkit-transform: rotate(0deg)
    -moz-transform: rotate(0deg)
    -o-transform: rotate(0deg)
    transform: rotate(0deg)
    -webkit-transition: .25s ease-in-out
    -moz-transition: .25s ease-in-out
    -o-transition: .25s ease-in-out
    transition: .25s ease-in-out

  #nav-icon span:nth-child(1)
    top: 0px
    -webkit-transform-origin: left center
    -moz-transform-origin: left center
    -o-transform-origin: left center
    transform-origin: left center

  #nav-icon span:nth-child(2)
    top: 7px
    -webkit-transform-origin: left center
    -moz-transform-origin: left center
    -o-transform-origin: left center
    transform-origin: left center

    @media screen and (min-width: $break-small)
      top: 11px

    @media screen and (min-width: $break-medium)
      top: 14px

    @media screen and (min-width: $break-large)
      top: 16px

  #nav-icon span:nth-child(3)
    top: 15px
    -webkit-transform-origin: left center
    -moz-transform-origin: left center
    -o-transform-origin: left center
    transform-origin: left center

    @media screen and (min-width: $break-small)
      top: 22px

    @media screen and (min-width: $break-medium)
      top: 28px

    @media screen and (min-width: $break-large)
      top: 32px

  #nav-icon.open span:nth-child(1)
    -webkit-transform: rotate(45deg)
    -moz-transform: rotate(45deg)
    -o-transform: rotate(45deg)
    transform: rotate(45deg)
    top: 0px
    left: 4px

    @media screen and (min-width: $break-small)
      top: 0px
      left: 4px

    @media screen and (min-width: $break-medium)
      top: 0px
      left: 4px

    @media screen and (min-width: $break-large)
      top: 0px
      left: 4px

  #nav-icon.open span:nth-child(2)
    width: 0%
    opacity: 0

  #nav-icon.open span:nth-child(3)
    -webkit-transform: rotate(-45deg)
    -moz-transform: rotate(-45deg)
    -o-transform: rotate(-45deg)
    transform: rotate(-45deg)
    top: 17px
    left: 4px

    @media screen and (min-width: $break-small)
      top: 23px
      left: 4px

    @media screen and (min-width: $break-medium)
      top: 27px
      left: 4px

    @media screen and (min-width: $break-large)
      top: 31px
      left: 4px
</style>



// WEBPACK FOOTER //
// NavigationIcon.vue?1cf30bf7